import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const defaultState = {
  loginID: '',
  nexonName: '',
  couponCount: 0,
  balance: {
    total: 0,
    currencyName: '',
    currencyUnit: '원'
  },
  couponUsable: {
    lastPurchaseProductCouponId: 0,
    pageSize: 25,
    couponUsableList: [],
    last: false
  },
  couponUnusable: {
    lastPurchaseProductCouponId: 0,
    pageSize: 25,
    couponUnusableList: [],
    last: false
  },
  purchase: {
    purchaseList: [],
    totalCount: 0,
    totalPageCount: 0,
    pageNo: 1, // 실제 서버 pageNo는 0부터지만 프론트 UI 처리 공통화를 위해 1로 해둠. (따라서 네트워크 요청시에 -1 응답시에 +1 함)
    pageSize: 15
  },
  alltemPurchaseProductList: [],
  withdraw: {
    purchaseWithdrawList: [],
    totalCount: 0,
    totalPageCount: 0,
    pageNo: 1, // 실제 서버 pageNo는 0부터지만 프론트 UI 처리 공통화를 위해 1로 해둠. (따라서 네트워크 요청시에 -1 응답시에 +1 함)
    pageSize: 15
  },
  rewardInfo: {
    thisMonthReward: 0,
    lastMonthReward: 0,
    twoMonthsAgoReward: 0
  },
  alltemPurchaseStartDate: '',
  alltemPurchaseEndDate: ''
}

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations
}
